import { render, staticRenderFns } from "./product-price-modal.vue?vue&type=template&id=27bdf5bf&scoped=true"
import script from "./product-price-modal.vue?vue&type=script&lang=js"
export * from "./product-price-modal.vue?vue&type=script&lang=js"
import style0 from "./product-price-modal.vue?vue&type=style&index=0&id=27bdf5bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bdf5bf",
  null
  
)

export default component.exports